import fb from '@/firebaseConfig';
import moment from 'moment';
import { getRandomId, isToday } from '@/helpers/helpers';

/*

  STATE

 */

const state = {
  morningId: '',
  morningViewedAt: '',

  dayId: '',
  dayViewedAt: '',

  nightId: '',
  nightViewedAt: '',

  generatedAt: '',
  dailyCardsLoaded: false,
};


/*

  GETTERS

 */

const getters = {
  dailyIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    let { morningId, dayId, nightId } = state;
    morningId = allCards[morningId] ? morningId : 'bubbles';
    dayId = allCards[dayId] ? dayId : 'applause';
    nightId = allCards[nightId] ? nightId : 'beach';
    return [ morningId, dayId, nightId ];
  },
  morningViewedToday: state => isToday(state.morningViewedAt),
  dayViewedToday: state => isToday(state.dayViewedAt),
  nightViewedToday: state => isToday(state.nightViewedAt),
};


/*

  ACTIONS

 */

const actions = {

  init({ dispatch, state, rootState, rootGetters }) {
    const { generatedAt, dailyCardsLoaded } = state;
    const generatedToday = isToday(generatedAt);
    const { isLoaded } = rootState.cards;
    const isSignedIn = rootGetters['user/isSignedIn'];

    if (dailyCardsLoaded && isSignedIn && !generatedToday && isLoaded) {
      dispatch('generateDailyCards');
    }
  },

  generateDailyCards({ commit, rootState }) {
    const userId = rootState.user.uid;
    const { lighteningIds, journeyIds, deepeningIds } = rootState.cards;

    const data = {
      morningId: getRandomId(lighteningIds),
      morningViewedAt: '',
      dayId: getRandomId(journeyIds),
      dayViewedAt: '',
      nightId: getRandomId(deepeningIds),
      nightViewedAt: '',
      generatedAt: moment().format(),
    };
    commit('setDailyCards', data);

    fb.usersCollection.doc(userId)
      .update({ dailyCards: data })
      .catch((error) => {
        console.log('Error saving daily cards', error);
      });
  },


  updateViewedTime({ commit, dispatch, getters, rootState }, cardId) {
    const userId = rootState.user.uid;
    const { dailyIds } = getters;
    const index = dailyIds.indexOf(cardId);
    const times = ['morning', 'day', 'night'];
    const timeOfDay = times[index];

    if (timeOfDay) {
      const viewedToday = getters[`${timeOfDay}ViewedToday`];
      if (!viewedToday) {
        const viewedAt = moment().format();

        commit('setViewedAt', { timeOfDay, viewedAt });

        fb.usersCollection.doc(userId)
          .update({ [`dailyCards.${timeOfDay}ViewedAt`]: viewedAt })
          .catch((error) => {
            console.log('Error updating daily cards', error);
          });

        dispatch('analytics/viewDailyCard', { timeOfDay, cardId }, { root: true });
      }
    }
  },

};


/*

  MUTATIONS

 */

const mutations = {

  setDailyCards(state, data) {
    if (data) {
      state.morningId = data.morningId || '';
      state.morningViewedAt = data.morningViewedAt || '';
      state.dayId = data.dayId || '';
      state.dayViewedAt = data.dayViewedAt || '';
      state.nightId = data.nightId || '';
      state.nightViewedAt = data.nightViewedAt || '';
      state.generatedAt = data.generatedAt || '';
      state.dailyCardsLoaded = true;
    }
  },

  setViewedAt(state, { timeOfDay, viewedAt }) {
    state[`${timeOfDay}ViewedAt`] = viewedAt;
  },

};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
